module.exports = "img/flags/LT.80eb968.png";